import React, { useEffect } from "react";
import { organigrama } from "../../json/organigrama";
import "./organigrama.css";

const Organigrama = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
    <div className="container">
      <div className="row">
        <div className="col_12">
          <div className="servicios_title">
            <h1 className="centrado">Organigrama</h1>
          </div>
        </div>
      </div>
      </div>
      <div className="container m-0">
      <div className="row">
        <div className="col-md-12">
          <div class="tree">
            <ul class="first">
              <li class="first techops">
                <span class="box">
                  <div class="avatar"></div>
                  Department Area Name
                  <br />
                  <strong>Director</strong>
                  <br />
                  John Smith
                </span>
                <ul>
                  <li>
                    <span class="box">
                      <div class="avatar"></div>Manager
                      <br />
                      Jane Smith
                    </span>
                    <ul>
                      <li>
                        <span class="box">
                          <div class="avatar"></div>Team Leader
                          <br />
                          John Doe
                        </span>
                        <ul>
                          <li>
                            <span class="box">
                              <div class="avatar"></div>Next Title
                              <br />
                              Next Name
                            </span>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <span class="box">
                          <div class="avatar"></div>Team Leader
                          <br />
                          Jane Doe
                        </span>
                      </li>
                      <li>
                        <span class="box">
                          <div class="avatar"></div>Team Leader
                          <br />
                          Jeff Doe
                        </span>
                      </li>
                      <li>
                        <span class="box">
                          <div class="avatar"></div>Team Leader
                        </span>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <span class="box">
                      <div class="avatar"></div>Manager 2
                    </span>
                    <ul>
                      <li>
                        <span class="box">
                          <div class="avatar"></div>Name 3
                        </span>
                      </li>
                      <li>
                        <span class="box">
                          <div class="avatar"></div>Name 4
                        </span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
        
      </div>
      
    </>
    
    
  );
};

export default Organigrama;
